import { Box, Button, Flex, Heading, HStack, Icon, Spinner, Text, VStack } from "@chakra-ui/react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FiArrowLeft, FiCheckCircle, FiArrowRight } from "react-icons/fi";
import { getVotingResults, VotingResults } from "@lubbezposrednio-frontend/core";
import { AdaptiveShell } from "../OrganizerDashboardView/components/AdaptiveShell";
import { VotingResultsContent } from "../ResultsView/VotingResultsContent";

// Renderowany albo jako trasa /glosowanie/:id/zakonczone (czyta name/endDate z location.state),
// albo INLINE z VotingView (dynamiczny status) — wtedy name/endDate przychodzą propsami.
export const VotingFinishedScreen: React.FC<{ name?: string; endDate?: string }> = ({ name: nameProp, endDate: endDateProp }) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: { name?: string; endDate?: string } };
  const name = nameProp ?? state?.name;
  const endDate = endDateProp ?? state?.endDate;
  const [results, setResults] = useState<VotingResults | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Głosowanie zakończone";
    if (!id) {
      setLoading(false);
      return;
    }
    getVotingResults(id)
      .then(res => setResults(res.data))
      .catch(() => undefined)
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <AdaptiveShell>
      <Box w="100%" maxW="780px" mx="auto" px={{ base: "16px", md: "20px" }} py={{ base: "32px", md: "48px" }}>
        <Button onClick={() => navigate(-1)} variant="ghost" size="sm" color="gray.500" leftIcon={<Icon as={FiArrowLeft} />} mb="14px" fontWeight="700" _hover={{ color: "primary" }}>
          Wstecz
        </Button>
        <VStack spacing="10px" textAlign="center" mb="28px">
          <HStack spacing="6px" bg="rgba(107,114,128,0.12)" color="#6b7280" px="12px" py="5px" borderRadius="full">
            <Icon as={FiCheckCircle} boxSize="14px" />
            <Text fontSize="13px" fontWeight="700">
              Zakończone
            </Text>
          </HStack>
          <Heading fontSize={{ base: "26px", md: "32px" }} fontWeight="800" color="primary">
            Głosowanie zakończone
          </Heading>
          {name && (
            <Text fontSize="16px" color="gray.500">
              {name}
              {endDate ? ` · ${endDate}` : ""}
            </Text>
          )}
        </VStack>

        {loading ? (
          <Flex justify="center" py="60px">
            <Spinner color="primary" size="lg" />
          </Flex>
        ) : results ? (
          <VotingResultsContent results={results} votingId={id} />
        ) : (
          <Box bg="white" borderRadius="18px" border="1px solid rgba(67,0,152,0.08)" boxShadow="0 6px 20px rgba(67,0,152,0.05)" p="28px" textAlign="center">
            <Text fontSize="16px" fontWeight="700" color="primary" mb="6px">
              Wyniki nie są publiczne
            </Text>
            <Text fontSize="14px" color="gray.500">
              To głosowanie zakończyło się, ale jego wyniki nie zostały udostępnione publicznie.
            </Text>
          </Box>
        )}

        <Flex justify="center" mt="28px">
          <Button as={Link} to="/aktywne-glosowania" variant="outline" borderColor="primary" color="primary" borderRadius="12px" fontWeight="700" rightIcon={<FiArrowRight />} _hover={{ bg: "rgba(67,0,152,0.05)" }}>
            Inne głosowania
          </Button>
        </Flex>
      </Box>
    </AdaptiveShell>
  );
};
